import { AccessFlowFormData } from '@AccessFlows/common/types';
import { createContext, PropsWithChildren, useContext, useState } from 'react';

interface AccessFlowFormContextProps {
  formData: AccessFlowFormData;
  isReviewing?: boolean;
  hasAccessTargetsReviewErrors?: boolean;
  setIsReviewing: (value: boolean) => void;
  setHasAccessTargetsReviewErrors: (value: boolean) => void;
}

const noop = () => {
  // noop
};

const AccessFlowFormContext = createContext<AccessFlowFormContextProps>({
  formData: {} as AccessFlowFormData,
  isReviewing: false,
  hasAccessTargetsReviewErrors: false,
  setIsReviewing: noop,
  setHasAccessTargetsReviewErrors: noop,
});

export const useAccessFlowFormContext = () => {
  return useContext(AccessFlowFormContext);
};

export const AccessFlowFormProvider = ({ children, formData }: PropsWithChildren<{ formData: AccessFlowFormData }>) => {
  const [isReviewing, setIsReviewing] = useState(false);
  const [hasAccessTargetsReviewErrors, setHasAccessTargetsReviewErrors] = useState(false);

  return (
    <AccessFlowFormContext.Provider
      value={{ formData, isReviewing, setIsReviewing, hasAccessTargetsReviewErrors, setHasAccessTargetsReviewErrors }}
    >
      {children}
    </AccessFlowFormContext.Provider>
  );
};
